import { MonitorSmartphone, Smartphone } from "lucide-react";
import { useApi } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { RevokeButton } from "@/components/RevokeButton";

const isPhone = (d) => /Android|iPhone|iPad/.test(d);

export const LoginHistory = () => {
  const { data, reload } = useApi("/auth/sessions");
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4" data-testid="login-history">
      <div className="flex items-center gap-3 mb-3">
        <span className="h-9 w-9 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-700 text-white flex items-center justify-center"><MonitorSmartphone className="h-4 w-4" /></span>
        <div>
          <div className="font-semibold text-slate-800">Riwayat Login</div>
          <div className="text-[11px] text-slate-500">Perangkat yang sedang masuk ke akun Anda</div>
        </div>
      </div>
      <div className="space-y-2">
        {data?.map((s) => {
          const Icon = isPhone(s.device) ? Smartphone : MonitorSmartphone;
          return (
            <div key={s.ref} className="flex items-center gap-3 border border-slate-100 rounded-xl px-3 py-2.5" data-testid={`login-session-${s.ref}`}>
              <Icon className="h-5 w-5 text-slate-500 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-slate-800 truncate">
                  {s.device}
                  {s.current && <span className="ml-1.5 text-[10px] font-bold text-emerald-700 bg-emerald-50 rounded px-1.5 py-0.5" data-testid="login-session-current">Perangkat ini</span>}
                </div>
                <div className="text-[11px] text-slate-500">Terakhir aktif {fmtDateTime(s.last_seen)}</div>
                <div className="text-[11px] text-slate-400">Masuk {fmtDateTime(s.created_at)}{s.ip ? ` • IP ${s.ip}` : ""}</div>
              </div>
              {!s.current && <RevokeButton sessRef={s.ref} device={s.device} label="Keluarkan" testid={`login-session-revoke-${s.ref}`} onDone={reload} />}
            </div>
          );
        })}
        {data?.length === 0 && <p className="text-xs text-slate-500">Tidak ada perangkat aktif.</p>}
      </div>
    </div>
  );
};
